import { useDispatch } from "react-redux";
const useAppDispatch = useDispatch;
export default useAppDispatch;
